module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "head-tabs"
  }, _vm._l((_vm.data), function(m, i) {
    return _c('span', {
      key: m.id,
      class: {
        'active': _vm.tabstate[i]
      },
      on: {
        "click": function($event) {
          _vm.change(i)
        }
      }
    }, [_vm._v(_vm._s(m))])
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67a2b65f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iexplore/components/tabs/src/Tabs.vue
// module id = 1240
// module chunks = 2